// extracted by mini-css-extract-plugin
export var bottomRightDock = "_1o-0";